export const SHOW_UNLOCK_LEVEL_POPUP = 'SHOW_UNLOCK_LEVEL_POPUP';
export const HIDE_UNLOCK_LEVEL_POPUP = 'HIDE_UNLOCK_LEVEL_POPUP';



// WEBPACK FOOTER //
// ./src/store/modules/popup/mutation-types.js